// const DefaultImageMap = {
//     'greeting_card': '/images/products/defaultProductImages/card.jpg',
//     'journal': '/images/products/defaultProductImages/notebook.jpg',
//     'photo_tile': '/images/products/defaultProductImages/photoTile.jpg',
//     'cushion': '/images/products/defaultProductImages/cushion.jpg',
//     'jigsaw': '/images/products/defaultProductImages/jigsaw.jpg',
//     'photobook': '/images/products/defaultProductImages/photobook.jpg'
// }
//
// export default DefaultImageMap;

const DefaultImageMap = (category, seoCategorySlug = 'personalised') => {
    return `/images/products/default-product-images/${seoCategorySlug}/${category}.webp`;
};

export default DefaultImageMap;